OE.addPlugin('Search', (function(){

    var Plugin = {},
        Options = {
        },
        querySelector = '[href="#searchform"]';


    Plugin.init = function()
    {
        addSearchButtonEvent();
    };

    var addSearchButtonEvent = function(element)
    {
        if(typeof element === 'undefined')
        {
            var buttons = OE.$doc.querySelectorAll(querySelector),
                button_count = buttons.length;

            for(var i = 0; i < button_count; i++)
            {
                addSearchButtonEvent(buttons[i]);
            }
        }
        else
        {
            if(OE.Utils.matches(element, querySelector))
            {
                element.addEventListener(OE.CLICK, toggleSearchForm);
            }
        }
    };

    var toggleSearchForm = function(e)
    {
        var is_event = e instanceof Event,
            element = is_event ? this : e,
            searchform = getSearchForm();

        if(searchform)
        {
            if(searchform.classList.contains('is--active'))
            {
                searchform.classList.remove('is--active');
                element.classList.remove('is--active');
            }
            else
            {
                searchform.classList.add('is--active');
                element.classList.add('is--active');
            }

            if(is_event)
            {
                e.preventDefault();
                return false;
            }
        }
    };

    var getSearchForm = function(root)
    {
        if(typeof root === 'undefined')
        {
            root = OE.$doc;
        }

        var searchform = root.querySelector('.header__widget.widget_search');

        if(searchform)
        {
            return searchform;
        }

        return null;
    };

    return Plugin;
})());
